import { config } from './config';

const _env = {
  production: false,
  envName: 'dev',
  baseUrl: 'https://api-v2-dev.eyrus.com',
  apexUrl: 'https://app-dev.eyrus.com/project/{projectId}/home',
  sentryDsn: 'https://a01c175a17234983b52bbc384b194994@sentry.io/1798679',
  firebase: {},
  // Google Analytics
  ga: {
    url: 'https://www.googletagmanager.com/gtag/js?id=UA-71851211-4',
    ua: 'UA-71851211-4'
  },
  stripe: {
    key: 'pk_test_Zrvkt1LgTmJnJIXO41DniARS'
  }
};

export const environment = { ..._env, ...config() };
